import { missingInput, divisionByZero } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/** SPEC-008 §21/METRIC-REQ-006 — CPL = investment / leads. */
export function cpl(investment: number | null, leads: number | null): FormulaResult {
  const explanation = {
    metric: 'cpl',
    formula: 'investment / leads',
    inputs: { investment, leads },
    result: null,
    unit: 'minor_currency_per_lead',
  };
  if (investment === null || leads === null) {
    return formulaUnknown(explanation, [missingInput('Investment and lead count are both required to calculate CPL.')]);
  }
  if (leads === 0) {
    return formulaUnknown(explanation, [divisionByZero('CPL is undefined when there are zero leads.')]);
  }
  return formulaOk(investment / leads, { ...explanation, result: investment / leads }, []);
}
